module.exports = __webpack_public_path__ + "img/ar.54914805.svg";